import React from "react";
import { useTranslation } from 'react-i18next'

const Setpapply = ({registrtion_setp_info}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="cfan-step-apply instruction-registration">
        <div className="container">
            <div className="step-content-wrapper d-flex ">
                <div className="step-content">
                    <div className="steps-data-wrapper">
                        {registrtion_setp_info.map((item,index) => (
                            <>
                            <h3>{item.title}</h3>
                            {item.type? <p>{item.descrtion}</p> : ''}
                            {item.lists &&  item.lists.length !== 0? <ul>
                             {item.lists.map((listItem, index) => (
                                <li key={index}>{listItem}</li>
                                ))}
                            </ul> : ''}
                               {!item.type? <p>{item.descrtion}</p> : ''}
                            </>
                        )

                    )}
                    </div>
                </div>
                <div className="step-image">
                <img alt="" className="step-logo" src="img/cfn-banner-logo.svg"/>
                    <img className="content-image" src="img/cfan_apply_data.jpg"/>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Setpapply;